import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {Box, Typography} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import CustomTable from "../customTable/CustomTable";
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {ElectionService} from "../Election/ElectionService";
import moment from "jalali-moment";
import {Pagination} from "@material-ui/lab";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

const ElectionVoteList = ({openDialog, handleClose, selectedItemId, electionId}) => {

    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new ElectionService(fundID, token, snackbar, loading)

    const [pageCount, setPageCount] = useState(0);

    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });
    //Dialog-end

    const [voteUserList, setVoteUserList] = useState([]);

    useEffect(() => {
        if (selectedItemId >= 0) {
            getListDataFromServer()
        }
    }, [selectedItemId])


    function getListDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getElectionVotes(fundID, electionId, selectedItemId, page)
            .then(response => {
                setVoteUserList([])
                response.data.map((item, index) => {
                    setVoteUserList((prevState => [
                        ...prevState, {
                            number: (page * 20) + index + 1,
                            name: item.firstName + item.lastName,
                            username: item.username,
                            date: moment(item.submitAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'),
                        }
                    ]))
                })
                setPageCount(response.totalPage)

                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason,"خطا در دریافت جزئیات آرا",snackbar,loading)
        })
    }

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    return (
        <Dialog
            className="w-100"
            onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
            id="PersonalizedMediumDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                جزئیات آرا
            </DialogTitle>
            <section className="flex-grow-1 d-flex flex-column" style={{padding: "1rem"}}>
                <div className="m-4 flex-grow-1 h-100">
                    <CustomTable
                        header={columns}
                        data={voteUserList}
                        title={"هیچ کاربری به این گزینه رای نداده است!"}
                    />
                </div>
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </Dialog>
    )
}

export default ElectionVoteList;


const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'name', label: 'نام و نام خانوادگی', align: 'right'},
    {id: 'username', label: 'نام کاربری', align: 'right'},
    {id: 'date', label: 'تاریخ ثبت', align: 'right'},
];